import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

export function restrictMentorAccess(Component) {
  const allowAccess = isMentor => !isMentor

  const RestrictMentorAccess = props => {
    useEffect(() => {
      if (!allowAccess(props.isMentor)) {
        props.dispatch(push('/notfound'))
      }
    })

    return allowAccess(props.isMentor) ? <Component {...props} /> : null
  }

  RestrictMentorAccess.propTypes = {
    dispatch: PropTypes.func,
    isMentor: PropTypes.bool
  }

  const mapStateToProps = state => ({
    isMentor: state.auth.isMentor
  })

  return connect(mapStateToProps)(RestrictMentorAccess)
}
